import * as React from "react";
import { observer } from "mobx-react";
import { computed } from "mobx";
import { Button } from "./Button";
import { DialogStore, DialogResult, DialogType } from "../Stores/DialogStore";
import { Strings } from "../Stores/StringsStore";
import { IButtonProps } from "./IButtonProps";

@observer
export class ConfirmButton extends React.Component<IButtonProps> {

	@computed get tooltip() {
		let tooltip = "";
		switch (DialogStore.dialogType) {
			case DialogType.Default:
				tooltip = Strings.general.yes;
				break;
			case DialogType.DeleteConfirmation:
				tooltip = Strings.general.ok;
				break;
			case DialogType.Feedback:
				tooltip = Strings.reader.send;
				break;
			case DialogType.None:
				tooltip = "";
				break;
		}
		return tooltip;
	}

	render() {
		return <Button {...this.props} title={this.props.title ? this.props.title : this.tooltip}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<polygon points="29.17 4.5 11.82 21.84 2.83 12.85 0 15.68 8.99 24.67 8.99 24.68 11.82 27.5 32 7.32 29.17 4.5" />
				</svg>
			</i>
		</Button>;
	}
}
